/* Restores jQuery plugins after a third-party jQuery swap.
   The Teeinblue app embed loads its own jQuery from cdnjs; when it executes it
   replaces window.jQuery, and every plugin vendors.js registered (fancybox,
   waypoint, ...) vanishes with the old instance. Depending on timing the swap
   lands before or after DOMContentLoaded, which is why product-section init
   crashed on some loads ("$(...).fancybox is not a function") and not others.
   tia-flickity-bridge.js already covers Flickity from its globals; this bridge
   covers everything else by capturing the decorated instance right here —
   loaded with defer immediately after vendors.js, so `window.jQuery` at this
   moment is the theme's fully-decorated copy — and copying any missing fn
   plugins (plus the $.fancybox static) onto whichever jQuery is current later.
   A stub installed by the layout guard is marked __tiaStub and gets replaced
   by the real plugin when available. */
(function () {
  var decorated = window.jQuery;
  function restore() {
    try {
      var jq = window.jQuery;
      if (!jq || !jq.fn || !decorated || !decorated.fn || jq === decorated) return;
      for (var k in decorated.fn) {
        if (!(k in jq.fn) || (jq.fn[k] && jq.fn[k].__tiaStub)) jq.fn[k] = decorated.fn[k];
      }
      if (decorated.fancybox && (!jq.fancybox || jq.fancybox.__tiaStub)) jq.fancybox = decorated.fancybox;
    } catch (e) {}
  }
  /* 2026-09-06: Fancybox loads on demand. If the real plugin is still absent once fancybox.js
     has executed (a jQuery swap, or a hijacked registration), install the chainable no-op that
     used to live in the layout's DOMContentLoaded guard, so the theme's lightbox bindings
     degrade silently instead of throwing. It never overrides a real plugin. Called from
     window.loadFancybox() after tiaJqRestore and setupFancyboxDefaults. */
  window.tiaFancyboxGuard = function () {
    try {
      var jq = window.jQuery;
      if (!jq || !jq.fn || jq.fn.fancybox) return;
      jq.fn.fancybox = function () { return this; };
      jq.fn.fancybox.__tiaStub = true;
      if (!jq.fancybox) {
        jq.fancybox = { __tiaStub: true, defaults: { mobile: {} },
          destroy: function () {}, close: function () {}, open: function () {},
          getInstance: function () { return null; } };
      }
    } catch (e) {}
  };
  /* 2026-09-06: Fancybox loads on demand now; window.loadFancybox() calls this after it lands. */
  window.tiaJqRestore = restore;
  restore();
  document.addEventListener('DOMContentLoaded', restore);
  window.addEventListener('load', restore);
  setTimeout(restore, 1500);
  setTimeout(restore, 4000);
})();
